// Icons
export const StarsIcon = "/assets/icons/stars.svg";
export const ChevronRightIcon = "/assets/icons/chevron-right.svg";
export const ChevronDownIcon = "/assets/icons/chevron-down.svg";
export const ChevronUpIcon = "/assets/icons/chevron-up.svg";
export const DownloadIcon = "/assets/icons/download.svg";
export const DownloadDocIcon = "/assets/icons/download-doc.svg";
export const TruckIcon = "/assets/icons/truck.svg";
export const CheckCircleGreenIcon = "/assets/icons/check-circle-green.svg";
export const BadgeCheckPurpleIcon = "/assets/icons/badge-check-purple.svg";
export const BadgeCheckGreenIcon = "/assets/icons/badge-check-green.svg";
export const ArrowRightIcon = "/assets/icons/arrow-right.svg";
export const FileIcon = "/assets/icons/file.svg";
export const AccordionPlusIcon = "/assets/icons/accordion-plus.svg";
export const AccordionMinusIcon = "/assets/icons/accordion-minus.svg";
export const AvailableFilesIcon = "/assets/icons/available-files.svg";
export const SheetCloseIcon = "/assets/icons/sheet-close.svg";
export const GetPricingIcon = "/assets/icons/get-pricing.svg";

export const ChevronUpDownIcon = "/assets/icons/chevron-updown.svg";
export const CheckMarkIcon = "/assets/icons/check-mark.svg";
export const CloseXIcon = "/assets/icons/close-x.svg";
export const ArrowRightSmIcon = "/assets/icons/arrow-right-sm.svg";
export const ArrowRightSmDisabledIcon = "/assets/icons/arrow-right-sm-disabled.svg";
export const GradeCardIcon = "/assets/icons/grade-card.svg";

export const EyeIcon = "/assets/icons/eye.svg";
export const MultiplePagesIcon = "/assets/icons/multiple-pages.svg";
export const WarningHexagonIcon = "/assets/icons/warning-hexagon.svg";

// Tail Spend Icons
export const ShieldTickIcon = "/assets/icons/shield-tick.svg";
export const Loading01Icon = "/assets/icons/loading-01.svg";
export const OperationalBurdenIcon = "/assets/icons/operational-burden.svg";
export const ChartBreakoutSquareIcon = "/assets/icons/chart-breakout-square.svg";
export const CheckCircleIcon = "/assets/icons/check-circle.svg";
export const Loading02Icon = "/assets/icons/loading-02.svg";
export const TransparencyIcon = "/assets/icons/transparency.svg";
export const FlexibilityIcon = "/assets/icons/flexibility.svg";
export const ReliabilityIcon = "/assets/icons/reliability.svg";
export const ScalabilityIcon = "/assets/icons/scalability.svg";
export const Dataflow04Icon = "/assets/icons/dataflow-04.svg";
export const Globe02Icon = "/assets/icons/globe-02.svg";
export const DropIcon = "/assets/icons/drop.svg";
export const UsersLeftIcon = "/assets/icons/users-left.svg";
export const MessageNewIcon = "/assets/icons/MessageNewIcon.svg";
export const CloseRedIcon = "/assets/icons/close-red.svg";

// About Us Icons
// White-filled arrow for use on the coral filled CTAs. An SVG rendered through
// next/image cannot inherit the button's colour, so the white variant is its own
// asset alongside the currentColor arrow-right.svg.
export const ArrowRightWhiteIcon = "/assets/icons/arrow-right-white.svg";
export const AboutCheckCircleIcon = "/assets/icons/about-check-circle.svg";
export const LinkedInConnectIcon = "/assets/icons/linkedin-connect.svg";
export const AboutShipIcon = "/assets/icons/about-ship.svg";
export const AboutWarehouseIcon = "/assets/icons/about-warehouse.svg";
export const AboutPlatformIcon = "/assets/icons/about-platform.svg";
export const AboutSupportIcon = "/assets/icons/about-support.svg";

// Product page — CPD trust-factor sections
export const BadgeTopProductIcon = "/assets/icons/badge-top-product.svg";
export const BadgeInStockIcon = "/assets/icons/badge-in-stock.svg";
export const BadgeSoldUnitsIcon = "/assets/icons/badge-sold-units.svg";
export const FilePdfOutlineIcon = "/assets/icons/file-pdf-outline.svg";
export const DownloadCoralIcon = "/assets/icons/download-coral.svg";
export const DownloadGreyIcon = "/assets/icons/download-grey.svg";
export const ArrowCircleLeftIcon = "/assets/icons/arrow-circle-left.svg";
export const ArrowCircleRightIcon = "/assets/icons/arrow-circle-right.svg";
export const CheckCircleFilledGreenIcon = "/assets/icons/check-circle-filled-green.svg";
// Plain green tick — stuffing photos bullets (Figma 8520:3976 "check")
export const CheckGreen16Icon = "/assets/icons/check-green-16.svg";
export const ArrowRightCoralIcon = "/assets/icons/arrow-right-coral.svg";
export const CloseCoralIcon = "/assets/icons/close-coral.svg";
// Product hero action cards (Figma 8464:4178)
export const CardPricingIcon = "/assets/icons/card-pricing.svg";
export const CardSampleTruckIcon = "/assets/icons/card-sample-truck.svg";
// Product page sticky "Looking to buy" bar (Figma 8123:4820)
export const PackageCoralIcon = "/assets/icons/package-coral.svg";
export const ArrowRightCoral20Icon = "/assets/icons/arrow-right-coral-20.svg";
export const ArrowRightWhite20Icon = "/assets/icons/arrow-right-white-20.svg";
// 16px white arrow on filled coral CTAs (Figma "Trailing Icon")
export const ArrowRightWhite16Icon = "/assets/icons/arrow-right-white-16.svg";

// Product page — Elixir pricing banner (Figma 8497:3810 / 8482:9418)
export const ElixirLogoIcon = "/assets/icons/elixir-logo.svg";
export const TagCoralIcon = "/assets/icons/tag-coral.svg";
export const ElchemyWordmarkIcon = "/assets/icons/elchemy-wordmark.svg";

// Images
export const DocBlurImage = "/assets/images/docBlurImage.png";
